module.exports = __webpack_public_path__ + "static/media/fa-regular-400.b61fdaf2.ttf";